import PropTypes from 'prop-types'
import LinkButtonBox from '../ui/LinkButtonBox'

const CategoriasPrincipales = (props) => {
  return (
    <div className="row mt-3">
      <div className="col-6 col-sm-3 d-none d-md-block">
        <LinkButtonBox
          onClick={() => props.onClick(false)}
          texto="Productos"
          className="btn borde-normal-seleccion text-center"
          classNameIcono="fa fa-archive fa-5x"
        />
      </div>
      <div className="col-6 col-sm-3 d-none d-md-block">
        <LinkButtonBox
          onClick={() => props.onClick(false)}
          texto="Servicios"
          className="btn borde-normal-seleccion text-center"
          classNameIcono="fa fa-paint-brush fa-5x"
        />
      </div>
      <div className="col-6 col-sm-3 d-none d-md-block">
        <LinkButtonBox
          onClick={() => props.onClick(false)}
          texto="Vehículos"
          className="btn borde-normal-seleccion text-center"
          classNameIcono="fa fa-car fa-5x"
        />
      </div>
      <div className="col-6 col-sm-3 d-none d-md-block">
        <LinkButtonBox
          onClick={() => props.onClick(true)}
          texto="Scrap"
          className="btn borde-normal-seleccion text-center"
          classNameIcono="fa fa-recycle fa-5x"
        />
      </div>
      <div className="col-3 col-sm-3 p-0 d-block d-md-none">
        <LinkButtonBox
          onClick={() => props.onClick(false)}
          texto="Productos"
          className="btn text-dark f-size-13"
          classNameIcono="fa fa-archive fa-2x"
        />
      </div>
      <div className="col-3 col-sm-3 p-0 d-block d-md-none">
        <LinkButtonBox
          onClick={() => props.onClick(false)}
          texto="Servicios"
          className="btn text-dark f-size-13"
          classNameIcono="fa fa-paint-brush fa-2x"
        />
      </div>
      <div className="col-3 col-sm-3 p-0 d-block d-md-none">
        <LinkButtonBox
          onClick={() => props.onClick(false)}
          texto="Vehículos"
          className="btn text-dark f-size-13"
          classNameIcono="fa fa-car fa-2x"
        />
      </div>
      <div className="col-3 col-sm-3 p-0 d-block d-md-none">
        <LinkButtonBox
          onClick={() => props.onClick(true)}
          texto="Scrap"
          className="btn text-dark f-size-13"
          classNameIcono="fa fa-recycle fa-2x"
        />
      </div>
    </div>
  )
}

CategoriasPrincipales.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default CategoriasPrincipales
